import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MAINLAYOUT_LEGACY_FIELD_ORDER = [
  "display_default_dood_footer",
  "is_kiosk_layout"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  mainLayoutDescriptor: _generatedMainLayoutBlockDescriptor,
  mainLayoutBlocDefinition,
  mainLayoutDashboardLayout,
  mainLayoutConfig,
  mainLayoutResolveConfig,
  mainLayoutProperties,
} = doodBlockConfig(
  {
    name: "Main layout",
    componentType: 'MainLayoutComponent',
    category: 'layout',
    description: "Main layout.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'footer',
        name: "pages.blocks.main-layout.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'global_features',
        name: "pages.blocks.main-layout.global-features.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        allowedRoles: ['ADMIN'],
      }
    ]
  },

  () => ({
    display_default_dood_footer: propertyValue({
      type: 'checkbox',
      value: true,
      allowedRoles: ['ADMIN'],
      options: {
        label: "pages.blocks.main-layout.display-default-dood-footer.label",
        help: "pages.blocks.main-layout.display-default-dood-footer.help",
      }
    }),
    is_kiosk_layout: propertyValue({
      type: 'checkbox',
      value: false,
      allowedRoles: ['ADMIN'],
      options: {
        label: "pages.blocks.main-layout.is-kiosk-layout.label",
        help: "pages.blocks.main-layout.is-kiosk-layout.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.main-layout.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.main-layout.fieldset.options.label",
            fields: [
              "display_default_dood_footer",
              "is_kiosk_layout",
            ],
          },
          {
            legend: "pages.blocks.main-layout.fieldset.blocks.label",
            fields: ["footer", "global_features"],
          },
        ],
      },
    ],
  })
);

export function mainLayoutDescriptor(): IBlockDescriptor;
export function mainLayoutDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function mainLayoutDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMainLayoutBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMainLayoutBlockDescriptor, mainLayoutProperties, fieldOrder);
}

export {
  mainLayoutBlocDefinition,
  mainLayoutDashboardLayout,
  mainLayoutProperties,
  mainLayoutConfig,
  mainLayoutResolveConfig,
};

export type MainLayoutConfig = typeof mainLayoutConfig;
